import { IssueTemplateEntity, IssueTemplateEntityRaw } from '../types/apiDomain';

const getIssueTemplateEntityFromRaw = (raw: IssueTemplateEntityRaw): IssueTemplateEntity => ({
    ...raw,
    template: JSON.stringify(raw.template, undefined, 2)
});

export default getIssueTemplateEntityFromRaw;
